<template>
    <div class="c-a-select">
        <label class="c-a-select__label" :for="`input-${id}`">{{label}}</label>
        <div class="c-a-select__wrapper" :class="{'c-a-select__wrapper--with-icon' : icon}">
            <icon v-if="icon" class="c-a-select__icon c-a-select__icon--symbol" :icon="icon"></icon>
            <select
                :id="`input-${id}`"
                :name="`input-${id}`"
                class="c-a-select__select"
                :class="{'c-a-select__select--placeholder': value == null}"
                v-model="selectedVal"
            >
                <option class="c-a-select__placeholder" :value="''">{{placeholder}}</option>
                <option v-for="(option, index) in alternatives" :value="option.value" :key="`option-${index}`">{{option.text}}</option>
            </select>
            <span class="c-a-select__button">
                <icon :icon="'expand_more'"></icon>
            </span>
        </div>
    </div>
</template>

<script>
    import Icon from '../AtomIcon.vue'

    export default {
        props: [
            'id',
            'label',
            'alternatives',
            'icon',
            'value',
            'placeholder'
        ],

        components: {
            Icon
        },
         computed: {
            selectedVal: {
                get() {
                    return this.value === null ? '' : this.value;
                },
                set(newVal) {
                    this.$emit('input', newVal);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomSelect.vue